/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect } from 'react';
import { useParams } from 'umi';
import { PAGE_CONFIG } from './pageConfigFuncom';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import { ThemeContext } from '@home/wrappers/common';
import { IData, IStudioParams } from '../type';
import CasualHub from '../casualHub';
import '../casualHub/CasualOverview/index.scss';
import './index.scss';

interface IHomeProps extends IData {
  homeReqParams?: string;
}

const Home = (props: IHomeProps) => {
  const { studioData, studioInfo, homeReqParams } = props || {};
  const { themeValue } = useContext(ThemeContext);
  const { studioId } = useParams() as IStudioParams;
  const isCasual = studioId === 'casual';

  const reqParams = homeReqParams || '/home';

  useEffect(() => {
    if (isCasual) return;
    const element = document.querySelector('.dbh-studio-context');
    if (element) {
      (element as HTMLElement).classList?.add('dbh-studio-home-bg');
    }
    return () => {
      if (element) {
        (element as HTMLElement).classList.remove('dbh-studio-home-bg');
      }
    };
  }, [themeValue, isCasual]);

  if (isCasual) {
    return <CasualHub studioInfo={studioInfo} />;
  }

  return (
    <CommonPageRender
      key={`${studioId}-${reqParams}`}
      reqParams={reqParams}
      frameType='studio'
      // @ts-ignore
      pageConfigInit={PAGE_CONFIG}
      api={PAGE_CONFIG_API}
      studioData={studioData}
    />
  );
};

export default Home;
